import { render, staticRenderFns } from "./editphysique.vue?vue&type=template&id=5aeb5465&scoped=true"
import script from "./editphysique.vue?vue&type=script&lang=js"
export * from "./editphysique.vue?vue&type=script&lang=js"
import style0 from "./editphysique.vue?vue&type=style&index=0&id=5aeb5465&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb5465",
  null
  
)

export default component.exports